import { observer } from "mobx-react-lite";
import { useStore } from "../../stores/root-store-context";
import { StarOutlined, StarFilled } from '@ant-design/icons';

const FavoriteStar = observer(({ projectId }: { projectId: number }) => {
    const { favoriteProjectsStore, applicationStore } = useStore();
    const isFavorite = favoriteProjectsStore.ids.has(projectId);

    return (
        <div onClick={() => favoriteProjectsStore.toggle(Number(applicationStore.user?.id), projectId)} style={{ cursor: 'pointer' }}>
            {isFavorite ? (
                <StarFilled style={{ color: '#fadb14', fontSize: 18 }} />
            ) : (
                <StarOutlined style={{ color: '#999', fontSize: 18 }} />
            )}
        </div>
    );
});

export default FavoriteStar;